import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CertificationSection = () => {
  const certifications = [
  {
    id: 1,
    name: "FIFA Intermediary License",
    issuer: "FIFA",
    validUntil: "December 2027",
    status: "Active",
    icon: "Award",
    color: "success",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_191dd24aa-1767112451359.png",
    logoAlt: "FIFA official logo with blue and white colors on professional certificate document with gold seal and ribbon"
  },
  {
    id: 2,
    name: "CAF Agent Certification",
    issuer: "Confederation of African Football",
    validUntil: "June 2028",
    status: "Active",
    icon: "Shield",
    color: "secondary",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_154f39fd7-1771943342597.png",
    logoAlt: "CAF confederation emblem with African continent silhouette in green and gold colors on official certification document"
  },
  {
    id: 3,
    name: "FA Intermediary Registration",
    issuer: "The Football Association",
    validUntil: "March 2027",
    status: "Active",
    icon: "FileCheck",
    color: "primary",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_129280c47-1771943342297.png",
    logoAlt: "The Football Association three lions crest in royal blue on white background with official registration stamp"
  },
  {
    id: 4,
    name: "UEFA Agent License",
    issuer: "Union of European Football Associations",
    validUntil: "September 2027",
    status: "Active",
    icon: "Trophy",
    color: "accent",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1aa794bf8-1769504008124.png",
    logoAlt: "UEFA official emblem with stars circle design in blue and white on professional license certificate with holographic security features"
  },
  {
    id: 5,
    name: "GDPR Compliance Certificate",
    issuer: "European Data Protection Board",
    validUntil: "January 2028",
    status: "Active",
    icon: "Lock",
    color: "success",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_100029a2d-1767469405066.png",
    logoAlt: "GDPR compliance badge with EU flag stars and shield symbol on blue background with official certification number"
  },
  {
    id: 6,
    name: "ISO 27001 Information Security",
    issuer: "International Organization for Standardization",
    validUntil: "November 2027",
    status: "Active",
    icon: "ShieldCheck",
    color: "secondary",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1282d767d-1771943348928.png",
    logoAlt: "ISO 27001 certification logo with circular design and information security management system text on white certificate"
  }];


  return (
    <section className="py-12 md:py-16 lg:py-20 bg-muted">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full mb-4 md:mb-6">
            <Icon name="Award" size={20} color="var(--color-primary)" />
            <span className="text-sm md:text-base font-medium text-primary">Official Certifications</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-4 md:mb-6 font-headline">
            Verified Credentials & Licenses
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-3xl mx-auto">
            Our comprehensive certification portfolio demonstrates commitment to regulatory excellence and professional standards across all football governing bodies.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
          {certifications?.map((cert) =>
          <div
            key={cert?.id}
            className="bg-card rounded-xl border border-border p-6 md:p-8 hover:shadow-lg transition-all duration-300 group">

              <div className="flex items-start justify-between mb-6">
                <div className={`w-14 h-14 md:w-16 md:h-16 bg-${cert?.color}/10 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                  <Icon name={cert?.icon} size={28} color={`var(--color-${cert?.color})`} />
                </div>
                <div className="flex items-center gap-2 px-3 py-1 bg-success/10 rounded-full">
                  <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
                  <span className="text-xs font-medium text-success">{cert?.status}</span>
                </div>
              </div>

              <div className="mb-6">
                <div className="w-full h-32 md:h-36 bg-muted rounded-lg overflow-hidden mb-4">
                  <Image
                  src={cert?.logo}
                  alt={cert?.logoAlt}
                  className="w-full h-full object-cover" />

                </div>
                <h3 className="text-lg md:text-xl font-bold text-foreground mb-2 font-headline">
                  {cert?.name}
                </h3>
                <p className="text-sm md:text-base text-muted-foreground mb-4">
                  {cert?.issuer}
                </p>
              </div>

              <div className="pt-4 border-t border-border">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-muted-foreground">Valid Until</span>
                  <span className="font-medium text-foreground">{cert?.validUntil}</span>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="mt-10 md:mt-12 lg:mt-16 text-center">
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-card border border-border rounded-lg">
            <Icon name="CheckCircle2" size={20} color="var(--color-success)" />
            <span className="text-sm md:text-base text-foreground">
              All certifications verified and updated as of January 2026
            </span>
          </div>
        </div>
      </div>
    </section>);

};

export default CertificationSection;